export const PAY_FREQUENCY_TYPES = [
  {
    id: 'monthly',
    text: 'Monthly: Pay on a specific day each month',
  },
  {
    id: 'semi-monthly',
    text: 'Semi-Monthly: Two pay dates per month',
  },
  {
    id: 'bi-weekly',
    text: 'Bi-Weekly: Pay every two weeks',
  },
  {
    id: 'weekly',
    text: 'Weekly: Pay every week',
  },
] as const

export const PAY_CADENCE_DAYS = [
  { id: 'monday', text: 'Monday' },
  { id: 'tuesday', text: 'Tuesday' },
  { id: 'wednesday', text: 'Wednesday' },
  { id: 'thursday', text: 'Thursday' },
  { id: 'friday', text: 'Friday' },
  { id: 'saturday', text: 'Saturday' },
  { id: 'sunday', text: 'Sunday' },
] as const

export const LAST_DAY_OF_MONTH_LABEL =
  'One pay date falls on the last day of the month'

export const PAY_FREQUENCY_LABELS: Record<string, string> = {
  MONTHLY: 'Monthly',
  SEMI_MONTHLY: 'Semi-monthly',
  BI_WEEKLY: 'Bi-weekly',
  WEEKLY: 'Weekly',
  monthly: 'Monthly',
  'semi-monthly': 'Semi-monthly',
  'bi-weekly': 'Bi-weekly',
  weekly: 'Weekly',
}
